import { TOP, BOTTOM } from '../directions.js';
import { FRONT, BACK, INNER_TOP, INNER_BOTTOM } from '../side-ids';

export default {
  id: 'klappkarte-quer-1-148x105',
  sides: [
    {
      id: FRONT,
      shifts: {
        [TOP]: 1.5,
      },
    },
    {
      id: INNER_TOP,
      shifts: {
        [BOTTOM]: 1.5,
      },
    },
    {
      id: INNER_BOTTOM,
      shifts: {
        [TOP]: 1.5,
      },
    },
    {
      id: BACK,
      shifts: {
        [BOTTOM]: 1.5,
      },
    },
  ],
};
